import React, { ReactNode, useMemo } from 'react';
import { withTheme, DefaultTheme } from 'styled-components';
import { StyContainer, StyLinearAlign, StyTitleContent } from './styles';
import { Typography } from '../../Typography';
import { ProgressBar } from '..';
import { TColorProp } from 'styled-components';
import { TLabelSize } from '../../Typography/Label/styles';

/**
 * @todo - integrar com componente Label
 */

type LabelBarColor = 'neutral' | 'blue' | 'red' | 'orange' | 'green';
type PercentagePosition = 'top' | 'right';

interface ILabelBar {
  percentage?: number;
  percentagePosition?: PercentagePosition;
  color?: LabelBarColor;
  maxSize?: string | number;
  supportingText?: string;
  title?: string;
  customSupportingText?: ReactNode;
  showPercentage?: boolean;
  height?: string;
  customColor?: string;
  percentageLabelSize?: TLabelSize;
  percentageLabelColor?: TColorProp;
  theme?: DefaultTheme;
}

export const LabelBar: React.FC<ILabelBar> = withTheme(
  ({
    percentage = 0,
    maxSize,
    color,
    title,
    supportingText,
    percentagePosition = 'top',
    customSupportingText,
    height,
    customColor,
    showPercentage = true,
    percentageLabelSize = 'x-small',
    percentageLabelColor = 'neutral.400',
  }) => {
    const refixedSize = useMemo(
      () =>
        typeof maxSize === 'number'
          ? `${maxSize}px`
          : typeof maxSize === 'string' && !maxSize.endsWith('px')
          ? `${maxSize}px`
          : maxSize,
      [maxSize]
    );

    return (
      <StyContainer
        maxSize={refixedSize}
        $hasGap={percentagePosition === 'top' || !showPercentage}
      >
        <StyTitleContent $keepPercentageEnd={!title}>
          {title && <Typography.Label size="small">{title}</Typography.Label>}
          {showPercentage && percentagePosition === 'top' && (
            <Typography.Label
              size={percentageLabelSize as TLabelSize}
              color={percentageLabelColor as TColorProp}
            >
              {percentage}%
            </Typography.Label>
          )}
        </StyTitleContent>
        <StyLinearAlign>
          <ProgressBar.LinearBar
            percentage={percentage}
            color={color}
            height={height}
            customColor={customColor}
          />
          {showPercentage && percentagePosition === 'right' && (
            <Typography.Label
              size={percentageLabelSize as TLabelSize}
              color={percentageLabelColor as TColorProp}
            >
              {percentage}%
            </Typography.Label>
          )}
        </StyLinearAlign>
        {!customSupportingText && supportingText && (
          <Typography.Label size="x-small" color="neutral.400">
            {supportingText}
          </Typography.Label>
        )}
        {customSupportingText}
      </StyContainer>
    );
  }
);
